import React, { useEffect, useState } from "react";
import {
  getQueues,
  getWrapupCodes,
  getQueueWrapupCodes,
} from "../utilities/genesysCloudUtils";
import "../App.css";
import { Queues } from "./Queues";
import { WrapupCodesTable } from "./WrapupCodesTable";

const RATE_LIMIT_DELAY = 100; // Delay in milliseconds between API calls
const PAGE_SIZE = 500; // Number of items per page

export function QueuesMain({
  activeTab,
  checkedDivisions,
  setPageCount,
  pageNumber,
  setPageNumber,
  searchQueuesValue,
  searchWrapupCodesValue,
}) {
  const [queues, setQueues] = useState([]);
  const [wrapupCodes, setWrapupCodes] = useState([]);
  const [wrapupCodesPageCount, setWrapupCodesPageCount] = useState();
  const [enableLoading, setEnableLoading] = useState(true);
  const [pageSize, setPageSize] = useState(
    activeTab === "Queues" ? 50 : activeTab === "Wrapup Codes Table" ? 25 : 50
  );
  const [queueCache, setQueueCache] = useState({}); // Cache for queues

  useEffect(() => {
    generateQueues();
    // console.log("QueuesMain :", activeTab);
  }, [pageNumber, activeTab, checkedDivisions, searchQueuesValue]);

  useEffect(() => {
    if (queues.length > 0) {
      generateWrapupCodesAndQueueWrapupCodes();
    }
  }, [pageNumber, queues, searchWrapupCodesValue]);

  useEffect(() => {
    setEnableLoading(true);
    setPageNumber(1);
  }, [checkedDivisions]);

  const delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

  const generateQueues = () => {
    let opts = {
      pageSize: pageSize, // Number | Page size
      pageNumber: pageNumber,
      sortOrder: "ASC", // String | Ascending or descending sort order
      divisionId: checkedDivisions, // [String] | Include only queues in the specified division ID(s)
    };
    if (searchQueuesValue) {
      opts.name = `*${searchQueuesValue}*`; // String | Include only queues with the given name (leading and trailing asterisks allowed)
    }
    getQueues(opts).then((data) => {
      setQueues(data.entities);
      setPageCount(data.pageCount);
      setEnableLoading(false);
    });
  };

  const generateWrapupCodesAndQueueWrapupCodes = async () => {
    setEnableLoading(true);

    let opts = {
      pageSize: 500, // Number | Page size
      pageNumber: pageNumber,
      sortBy: "name", // String | Sort by
      sortOrder: "ascending", // String | Sort order
    };
    const wrapupCodesData = await getWrapupCodes(opts);
    setWrapupCodes(
      wrapupCodesData.entities.map((code) => ({ ...code, queues: [] }))
    );
    setWrapupCodesPageCount(wrapupCodesData.pageCount);
    // setPageCount(wrapupCodesData.pageCount);
    let wrapupCodeMap = {};
    let queueOpts = {
      pageSize: 500, // Number | Page size
      pageNumber: 1, // Number | Page number
    };
    // Fetch wrap-up codes for each queue with rate limiting and caching
    const promises = queues.map((queue, index) =>
      delay(index * RATE_LIMIT_DELAY).then(async () => {
        if (queueCache[queue.id]) {
          // Use cached data if available
          queue.wrapUpCodes = queueCache[queue.id];
          console.log("From cache");
        } else {
          const data = await getQueueWrapupCodes(queue.id, queueOpts);
          queue.wrapUpCodes = data.entities;

          // Cache the result
          setQueueCache((prevCache) => ({
            ...prevCache,
            [queue.id]: data.entities,
          }));

          // Map wrap-up codes to queues
          data.entities.forEach((code) => {
            if (!wrapupCodeMap[code.id]) {
              wrapupCodeMap[code.id] = { ...code, queues: [] };
            }
            wrapupCodeMap[code.id].queues.push(queue);
          });
        }
      })
    );

    await Promise.all(promises);

    setWrapupCodes(Object.values(wrapupCodeMap));
    setEnableLoading(false);
  };

  return (
    <>
      {activeTab === "Queues" ? (
        <Queues
          queues={queues}
          setQueues={setQueues}
          pageNumber={pageNumber}
          pageSize={pageSize}
          queueCache={queueCache}
          setQueueCache={setQueueCache}
        />
      ) : (
        <>
          {/* <Pagination
                pageCount={pageCount}
                pageNumber={pageNumber}
                onPageChange={onPageChange}
              /> */}
          <WrapupCodesTable
            queues={queues}
            queuePageNumber={pageNumber}
            activeTab={activeTab}
            searchWrapupCodesValue={searchWrapupCodesValue}
          />
        </>
      )}
    </>
  );
}
